import { useTheme } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

// Component
import TimeChipSelector from "components/TimeChipSelector";
import { StyledLabel } from '../StyledLabel';

export const StyledTimeChipSelector = ({
  width,
  showEditGeneral,
  label,
  timeList,
  max,
  isIndent,
  onAddTimeChip,
  onDeleteTimeChip,
}) => {
  const theme = useTheme();

  return (
    <StyledLabel
      {...{
        isIndent,
        label
      }}
    >
      <TimeChipSelector
        timeList={timeList}
        max={max}
        onAddTimeChip={onAddTimeChip}
        onDeleteTimeChip={onDeleteTimeChip}
      />
    </StyledLabel>
  );
};